if (!customElements.get(`product-info`)) {
  class ProductInfo extends HTMLElement {
    constructor() {
      super();

      this.sectionId = this.dataset.sectionId;
      this.isEnabledStickyContent = this.dataset.enabledStickyContent === 'true';
      if (this.isEnabledStickyContent) {
        this.setStickyHeight();
        window.addEventListener('resize', this.setStickyHeight.bind(this));
        document.addEventListener(`${PRODUCT_EVENT.updatedVariant}${this.sectionId}`, () => {
          this.setStickyHeight();
        });
        document.addEventListener(`${PRODUCT_EVENT.productDetailsLayoutChange}${this.sectionId}`, () => {
          this.setStickyHeight();
        });
        if (Shopify.designMode) {
          document.addEventListener("shopify:section:load", (event) => {
            if (!event.target.classList.contains('section-product-details') && !event.target.classList.contains('section-main-product')) return;
            this.setStickyHeight();
          });

          document.addEventListener("shopify:section:reorder", () => {
            this.setStickyHeight();
          });
        }
      }
    }

    isDesktopLayout() {
      return window.matchMedia(`(min-width: ${MIN_DEVICE_WIDTH.tablet}px)`).matches;
    }

    setStickyHeight() {
      const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`);
      if (this.isDesktopLayout()) {
        requestAnimationFrame(() => {
          const mediaWrapperEle = this.querySelector(`.product-template__media-wrapper[data-section-id="${this.sectionId}"]`);
          if (!mediaWrapperEle) return;
          const totalHeightMediaSide = mediaWrapperEle.getBoundingClientRect().height;
          const contentSideEle = this.querySelector(`.product-template__content-wrapper[data-section-id="${this.sectionId}"]`)
          const contentSideContainerEle = contentSideEle.querySelector(`.product-template__content__container`);
          contentSideEle.style.minHeight = `${totalHeightMediaSide}px`;

          // Writing min-height above can introduce/remove a scrollbar, which in
          // Firefox can flip the viewport back under the tablet breakpoint without
          // firing another resize event. Re-check and fall back to mobile layout
          // immediately instead of leaving a stale desktop-sized min-height applied.
          requestAnimationFrame(() => {
            if (!this.isDesktopLayout()) {
              contentSideEle.style.minHeight = 'auto';
              if (contentSideContainerEle) {
                contentSideContainerEle.classList.remove(`md:sticky`);
              }
              return;
            }
            if (totalHeightMediaSide >= contentSideEle.getBoundingClientRect().height) {
              if (contentSideContainerEle) {
                contentSideContainerEle.classList.add(`md:sticky`);
              }
            } else {
              if (contentSideContainerEle) {
                contentSideContainerEle.classList.remove(`md:sticky`);
              }
            }
          });
        })
      } else {
        contentSideEle.style.minHeight = 'auto';
      }
    }
  }

  customElements.define(`product-info`, ProductInfo);
}